module.exports = __webpack_public_path__ + "img/send_deal_data_min.7f86749f.jpg";